// extrato-operacoes-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Escolha um período de até 93 dias.": "Elija un período de hasta 93 días.",
};

export default catalogo;
